import { render, staticRenderFns } from "./ActionLink.vue?vue&type=template&id=e477a232"
import script from "./ActionLink.vue?vue&type=script&lang=js"
export * from "./ActionLink.vue?vue&type=script&lang=js"
import style0 from "./ActionLink.vue?vue&type=style&index=0&id=e477a232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports